<template>
    <search-select v-bind="$attrs" :options="options" :allow-empty="false" label="name" placeholder="Справочник команд" v-on="listeners" @input="$emit('input', $event)">
        <template slot="option" slot-scope="scope">
            <div class="d-flex align-items-center justify-content-between flex-truncate">
                <div class="text-truncate">{{ scope.option.name }}</div>
                <div class="ml-1">{{ scope.option.id }}</div>
            </div>
        </template>

        <template slot="singleLabel" slot-scope="scope">
            <div class="d-flex align-items-center justify-content-between flex-truncate">
                <div class="text-truncate">{{ scope.option.name }}</div>
                <div class="ml-1">{{ scope.option.id }}</div>
            </div>
        </template>
    </search-select>
</template>

<script>
import SearchSelect from '@/components/Select'

const options = [
    {
        id: 'set_mdb_exe_log=on',
        name: 'Включить сканер шины'
    },
    {
        id: 'set_mdb_exe_log=off',
        name: 'Выключить сканер шины'
    },
    {
        id: 'set_bus_autodetect=off',
        name: 'Выключить автоопределение шины'
    },
    {
        id: 'set_dp_pos_cash=N',
        name: 'Десятичная точка (нал)'
    },
    {
        id: 'set_dp_pos_cashless=N',
        name: 'Десятичная точка (безнал)'
    }
]

export default {
    components: {
        SearchSelect
    },

    inheritAttrs: false,

    computed: {
        options() {
            return options
        },

        listeners() {
            const { input, ...listeners } = this.$listeners
            return listeners
        }
    }
}
</script>
